import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import auth from 'src/services/auth';
import SKIN_NAME from 'src/enums/skinName';
import routerConfig from 'src/configs/routerConfig';
import ProtectedRoute from 'src/components/common/ProtectedRoute';
import BaseLayout from 'src/components/common/BaseLayout';
import { pageView } from 'src/utils/googleTag';
import { pagePendoView } from 'src/utils/pendoTag';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import { menuShow } from 'src/utils/menuDisplay';
import styles from '../common/BaseLayout/BaseLayout.module.less';
import AcceptableUsePolicy from 'src/components/AcceptableUsePolicy'; // Import the component if necessary

type AppViewProps = {};

const AppView: React.FC<AppViewProps> = () => {
  const { user } = useAppStateContext();
  const { pathname, search } = useLocation();
  const token = new URLSearchParams(search).get('token');
  const history = useHistory();
  const redirect = auth.getRedirect(token, { shouldCleanUp: true });

  React.useEffect(() => {
    if (pathname) {
      pageView(pathname); 
      pagePendoView(pathname);
    }
    if (user && user.appPermissions) {
      menuShow(history, user);
    }
  }, [pathname, user, history]);

  const hasIqHubPrivilege = !!(user?.otherPrivilege?.['IQ Hub'] || user?.otherPrivilege?.['IQ_Hub']);
  const skinName = auth.getSkin() ?? SKIN_NAME.Standard;
  const isAcceptableUsePolicyRoute = pathname === '/AcceptableUsePolicy';
  if (user && !hasIqHubPrivilege && !isAcceptableUsePolicyRoute) {
    return (
      <BaseLayout hasIqHubPrivilege={hasIqHubPrivilege}>
        <h2 className={styles.header}>
          IQhub permission is disabled on your Account. Please contact support.
        </h2>
      </BaseLayout>
    );
  }
  const newRouterConfig = routerConfig.map(route => {
    const skinTitle = skinName !== SKIN_NAME.Standard && skinName !== SKIN_NAME.DarkMode;
    
    return {
      ...route,
      title: skinTitle ? route.title.replace(/QL2/g, "") : route.title,
    };
  });

  return (
    <BaseLayout hasIqHubPrivilege={hasIqHubPrivilege}>
      <Switch>
        {redirect && <Redirect to={redirect} />}
        {newRouterConfig.map((route, ind) => {
          return route.protected ? (
            <ProtectedRoute key={ind} exact={route.exact} path={route.path} title={route.title}>
              <route.component />
            </ProtectedRoute>
          ) : (
            <Route key={ind} exact={route.exact} path={route.path}>
              {route.component === AcceptableUsePolicy || hasIqHubPrivilege ? <route.component /> : <Redirect to="/" />}
            </Route>
          );
        })}
        <Redirect from="*" to="/" />
      </Switch>
    </BaseLayout>
  );
};

export default AppView;
